export enum FcmSendMethodEnum {
  tokens = 'tokens',
  topics = 'topics',
}

export enum FCMTopicsEnum {
  allUsers = 'allUsers',
  allAdmins = 'allAdmins',
  allEmployers = 'allEmployers',
  allMerchants = 'allMerchants',
  allStudentBodies = 'allStudentBodies',
  allStandardUsers = 'allStandardUsers',
  allSuperUsers = 'allSuperUsers',
  webAppUsers = 'webAppUsers',
  androidAppUsers = 'androidAppUsers',
  iosAppUsers = 'iosAppUsers',
}

export enum FirebasePushNotificationSendToEnum {
  specificUsers = 'specificUsers',
  fcmTopics = 'fcmTopics',
}
